"use client";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  FormControlLabel,
  Grid,
  GridProps,
  Radio,
  RadioProps,
  Typography,
} from "@mui/material";
import Image from "next/image";
import React, { useEffect } from "react";
import SalifyFallback from "src/lib/components/salify-fallback/default";
import { useCardSectionContext } from "../context";

const PaymentForm = (props: React.PropsWithChildren<{}>) => {
  const { formValue, updateFormValue } = useCardSectionContext();
  const [paymentVendor, setPaymentVendor] = React.useState<any>(false);
  const [expanded, setExpanded] = React.useState<any>(false);

  useEffect(() => {
    setExpanded(formValue.paymentMethod);
  }, [formValue.paymentMethod]);

  useEffect(() => {
    setPaymentVendor(formValue.paymentVendor);
  }, [formValue.paymentVendor]);

  return (
    <Box>
      <Accordion expanded={expanded === 0} sx={{ m: "0px !important" }}>
        <AccordionSummary>
          <SalifyFallback.Label
            path="Cash"
            default="Thanh toán khi nhận hàng"
            render={(label) => (
              <FormControlLabel
                label={label}
                control={<Radio checked={expanded === 0} />}
                onClick={(event) => {
                  event.stopPropagation();
                  updateFormValue({ paymentMethod: 0 });
                }}
                onFocus={(event) => event.stopPropagation()}
              />
            )}
          />
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <SalifyFallback.Label path="Cash Description" default="Thanh toán khi nhận hàng" />
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion disabled expanded={expanded === 1} sx={{ m: "0px !important" }}>
        <AccordionSummary>
          <SalifyFallback.Label
            path="Bank"
            default="Ngân hàng"
            render={(label) => (
              <FormControlLabel
                label={label}
                control={<Radio checked={expanded === 1} />}
                onClick={(event) => {
                  event.stopPropagation();
                  updateFormValue({ paymentMethod: 1 });
                }}
                onFocus={(event) => event.stopPropagation()}
              />
            )}
          />
        </AccordionSummary>
        <AccordionDetails>YYY detail</AccordionDetails>
      </Accordion>
      <Accordion disabled expanded={expanded === 2} sx={{ m: "0px !important" }}>
        <AccordionSummary>
          <SalifyFallback.Label
            path="Card"
            default="Thẻ tín dụng/Ghi nợ"
            render={(label) => (
              <FormControlLabel
                label={label}
                control={<Radio checked={expanded === 2} />}
                onClick={(event) => {
                  event.stopPropagation();
                  updateFormValue({ paymentMethod: 2 });
                }}
                onFocus={(event) => event.stopPropagation()}
              />
            )}
          />
        </AccordionSummary>
        <AccordionDetails>YYY detail</AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 3} sx={{ m: "0px !important" }}>
        <AccordionSummary>
          <SalifyFallback.Label
            path="Digital Wallets"
            default="Ví điện tử"
            render={(label) => (
              <FormControlLabel
                label={label}
                control={<Radio checked={expanded === 3} />}
                onClick={(event) => {
                  event.stopPropagation();
                  updateFormValue({ paymentMethod: 3 });
                }}
                onFocus={(event) => event.stopPropagation()}
              />
            )}
          />
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={4}>
            {[
              // {
              //   value: 0,
              //   title: "Momo",
              //   icon: (
              //     <Image src="/assets/images/vendor/momo.svg" alt="me" width="64" height="64" />
              //   ),
              // },
              {
                value: 1,
                title: "VN Pay",
                icon: (
                  <Image src="/assets/images/vendor/vnpay.png" alt="me" width="64" height="64" />
                ),
              },
              {
                value: 2,
                title: "Appota Pay",
                icon: (
                  <Image
                    src="/assets/images/vendor/appotapay.png"
                    alt="me"
                    width="64"
                    height="64"
                  />
                ),
              },
            ].map((data, index) => {
              return (
                <CustomRadioIcons
                  key={index}
                  icon={data.icon}
                  data={data}
                  selected={paymentVendor}
                  color="primary"
                  name="custom-radios-icons"
                  gridProps={{ sm: 4, xs: 12 }}
                  handleChange={(value) => updateFormValue({ paymentVendor: value })}
                />
              );
            })}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

type CustomRadioIconsProps = {
  name: string;
  icon?: React.ReactNode;
  selected: any;
  gridProps: GridProps;
  color: RadioProps["color"];
  data: {
    value: any;
    title?: React.ReactNode;
    content?: React.ReactNode;
    isSelected?: boolean;
  };
  handleChange: (prop: string | React.ChangeEvent<HTMLInputElement>) => void;
};

const CustomRadioIcons = (props: CustomRadioIconsProps) => {
  // ** Props
  const { icon, color, name, selected, gridProps, data, handleChange } = props;

  const { title, value, content } = data;

  const renderComponent = () => {
    return (
      <Grid item {...gridProps}>
        <Box
          onClick={() => handleChange(value)}
          sx={{
            p: 4,
            height: "100%",
            display: "flex",
            borderRadius: 1,
            cursor: "pointer",
            position: "relative",
            alignItems: "center",
            flexDirection: "column",
            border: (theme) => `1px solid ${theme.palette.divider}`,
            ...(selected === value
              ? { borderColor: `rgb(210, 63, 87)` }
              : {
                  "&:hover": {
                    borderColor: (theme) => `rgb(210, 63, 87, 0.25)`,
                  },
                }),
          }}
        >
          {icon}
          {title ? (
            typeof title === "string" ? (
              <Typography sx={{ fontWeight: 500, ...(content ? { mb: 1 } : { my: "auto" }) }}>
                {title}
              </Typography>
            ) : (
              title
            )
          ) : null}
          {content ? (
            typeof content === "string" ? (
              <Typography variant="body2" sx={{ my: "auto", textAlign: "center" }}>
                {content}
              </Typography>
            ) : (
              content
            )
          ) : null}
          <Radio
            name={name}
            size="small"
            color={color}
            value={value}
            onChange={handleChange}
            checked={selected === value}
            sx={{ mb: -2, ...(!icon && !title && !content && { mt: -2 }) }}
          />
        </Box>
      </Grid>
    );
  };

  return data ? renderComponent() : null;
};

export default PaymentForm;
